import { z } from "zod"

export const Order = z.object({
  order: z.union([z.literal("asc"), z.literal("desc")]).default("asc"),
})

export type Order = z.infer<typeof Order>
